<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Action Card
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content">
  <h2>Customized Action Card</h2>
  <div class="content__tools-wrap">
    <div class="content__row">
      <div class="c-input-check-inline">
        <ng-container *ngIf="!isBrowser; else inputOptionControls">
          <form action="/action-card" method="get">
            <ng-container *ngTemplateOutlet="inputOptionControls"></ng-container>
            <maced-button buttonId="submit" label="Submit" buttonType="submit"></maced-button><br>
          </form>
          <h4>Note: You are in noJS mode, So please hit submit after the options changes.</h4>
        </ng-container>
      </div>
    </div>
  </div>
  <hr>
  <h2>Use Case: Action card</h2>
  <maced-action-card [actionCardId]="actionCardId1" [iconClass]="showIconClass ? iconClass : ''"
    [iconUrl]="showIconImage ? iconUrl : ''" [iconAltText]="iconAltText1" [hasIconClass]="hasIconClass" [title]="title1"
    [iconTitle]="iconTitle">
    <ng-container ngProjectAs="[actionCardDescription]">
      <div class="c-action-card__date">
        <p class="c-action-card__date-details">
          <label class="c-action-card__date-details-label">Start Date:</label>
          <span class="c-action-card__date-details-input">DD Month YYYY, HH:MM</span>
        </p>
        <p class="c-action-card__date-details">
          <label class="c-action-card__date-details-label">End Date:</label>
          <span class="c-action-card__date-details-input">DD Month YYYY, HH:MM</span>
        </p>
      </div>
    </ng-container>
    <ng-container ngProjectAs="[actionCardActions]">
      <div class="c-action-card__button-group-item">
        <maced-button buttonId="buttonId1" label="Primary Action" ariaLabel="Primary Action" color="primary">
        </maced-button>
      </div>
      <div class="c-action-card__button-group-item">
        <maced-dropdown dropdownId="dropdownId1" name="dropdownId1" ariaLabel="Dropdown More"
          cheveronClass="icon-dots-vertical" [options]="options" label="More">
        </maced-dropdown>
      </div>
    </ng-container>

    <ng-container ngProjectAs="[actionCardContent]">
      <div class="c-action-card__body-content">
        <maced-accordian-group *ngIf="showAccordian" accordianGroupId="accordianGroupId1">
          <maced-accordian accordianId="accordianId1" collapseLabel="Collapse" expandLabel="Expand"
            [hasContentBelow]="true" [hasIconLeftSide]="true" [hasActions]="false" [hasDefaultExpanded]="true">
            <ng-container ngProjectAs="[accordionContent]">
              <ng-container *ngTemplateOutlet="cardContentList"></ng-container>
              <ng-container *ngTemplateOutlet="indicators"></ng-container>
            </ng-container>
          </maced-accordian>
        </maced-accordian-group>
        <ng-container *ngIf="!showAccordian">
          <ng-container *ngTemplateOutlet="cardContentList"></ng-container>
          <ng-container *ngTemplateOutlet="indicators"></ng-container>
        </ng-container>
      </div>
    </ng-container>
  </maced-action-card>
</div>

<ng-template #inputOptionControls>
  <ng-container *ngIf="!isBrowser">
    <input id="showAccordian" class="c-input-check-inline__input" type="checkbox" name="showAccordian"
      [(ngModel)]="showAccordian">
    <label for="showAccordian" class="c-input-check-inline__label u-mr-15">
      Show Accordian
    </label>
  </ng-container>
  <input id="showIconClass" class="c-input-check-inline__input" type="checkbox" name="showIconClass"
    [(ngModel)]="showIconClass">
  <label for="showIconClass" class="c-input-check-inline__label u-mr-15">
    Show Icon Class
  </label>
  <input id="showIconImage" class="c-input-check-inline__input" type="checkbox" name="showIconImage"
    [(ngModel)]="showIconImage">
  <label for="showIconImage" class="c-input-check-inline__label u-mr-15">
    Show Icon Image
  </label>
  <input id="hasIconClass" class="c-input-check-inline__input" type="checkbox" name="hasIconClass"
    [(ngModel)]="hasIconClass">
  <label for="hasIconClass" class="c-input-check-inline__label u-mr-15">
    Has Icon Class
  </label>
</ng-template>

<ng-template #cardContentList>
  <div class="c-action-card__data">
    <ul class="c-action-card__data-list" role="list">
      <li *ngFor="let list of dummyList; let i = index" class="c-action-card__data-list-item" role="listitem">
        <label class="c-action-card__label">{{list.label}}</label>
        <div class="c-action-card__sub-text">
          <span class="c-action-card__sub-text-value">{{list.value}}</span>
          <maced-link [id]="'linkId'+i" [links]="list.link"></maced-link>
        </div>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #indicators>
  <div class="c-action-card__indicators">
    <ul class="c-action-card__indicators-list" role="list">
      <li *ngFor="let indicator of indicatorList;let i = index" class="c-action-card__indicators-list-item" role="listitem">
        <maced-indicator [color]="indicator.colorCode" [value]="indicator.value" [statusUrl]="indicator.statusUrl"
          [borderColor]="indicator.borderColor" [statusAriaLabel]="indicator.label" [hasValue]="true"
          [status]="indicator.status" [indicatorId]="'indicatorId' + i">
        </maced-indicator>
      </li>
    </ul>
  </div>
</ng-template>